import gsap from "gsap";
import Power2 from "gsap";

$(document).ready(function() {

    $('.read_more').on('click', function() {
        currentAnimation = this.animation;
        if(currentAnimation.reversed()) {
            currentAnimation.play();
            $(this).text($(this).attr('data-close'));
        } else {
            currentAnimation.reverse();
            $(this).text($(this).attr('data-open'));
        }
    });
});

var currentAnimation

$('.read_more').each(function(index, element){
    var $elemChild = $(this).parent().find('.text-wrapper');
    var child = new gsap.timeline({paused:true, reversed:true});
    child
        .to($elemChild, .5, { height: 'auto', ease:Power2.easeInOut}, 'animate');
    this.animation = child;
});